module.exports = __webpack_public_path__ + "img/D022526C-BB0E-4E6C-8395-1F3F849527D9 - ネガティブフェイスかみゃー.c63c0665.png";